export default __webpack_public_path__ + "static/media/l1.32e12b7c.png";